import { Component, inject, input, signal } from '@angular/core';
import { AnalyseService } from '../../../services/analyse-service';
import { ModalService } from '../../common/modal/modal-service';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-invitations',
  imports: [],
  templateUrl: './invitations.html',
  styleUrl: './invitations.scss',
})
export class Invitations {

  readonly modalService = inject(ModalService);
  private analyseService = inject(AnalyseService);
  private toastrService = inject(ToastrService);
  readonly allFamiliesUuid = input([]);
  readonly visibleFamiliesUuid = input([]);

  isGenerating = signal(false);

  async downloadAllInvitations(): Promise<void> {
    this.isGenerating.set(true);
    try {
      const blob = await this.analyseService.getAllInvitations();
      saveAs(blob, 'invitations_all.pdf');
      this.toastrService.success('Telechargement pret');
      this.modalService.discardModal(false);
    } catch {
      this.toastrService.error('Erreur de telechargement du fichier');
    } finally {
      this.isGenerating.set(false);
    }
  }

  async downloadAllAsZip(onlyVisibleFamilies: boolean) {
    this.isGenerating.set(true);
    try {
      const zip = new JSZip();
      const folder = zip.folder('invitations');

      for (const uuid of onlyVisibleFamilies ? this.visibleFamiliesUuid() : this.allFamiliesUuid()) {
        const blob = await this.analyseService.getSpecificInvitations([uuid]);
        folder!.file(`invitations_${uuid}.pdf`, blob);
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' });
      saveAs(zipBlob, 'invitations.zip');
      this.toastrService.success('Telechargement pret');
      this.modalService.discardModal(false);
    } catch {
      this.toastrService.error('Erreur de telechargement des fichiers');
    } finally {
      this.isGenerating.set(false);
    }
  }
}
